import { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";

import { ProvideAuth, useAuth } from "./auth";
import Login from "./pages/login/Login";
import SplashScreen from "./pages/splashScreen";
import NotAuthorized from "./pages/notAuthorized";
import RequestResetPassword from "./pages/reset_password/RequestResetPassword";
import ResetPassword from "./pages/reset_password/ResetPassword";
import AppLayout from "./AppLayout";
import Home from "./pages/home/Home";
import Users from "./pages/users/Users";
import Reporting from "./pages/Reporting";
import CareUnits from "./pages/care_units/CareUnits";
import SurgicalProcedures from "./pages/surgical_procedures/SurgicalProcedures";
import SurgicalIntervention from "./pages/surgical_intervention/SurgicalIntervention";
import Patient from "./pages/patient/Patient";
import Calendar from "./pages/calendar/Calendar";
import DailyOccupationChart from "./pages/reporting/DailyOccupationChart";
import DailySiipsChart from "./pages/reporting/DailySiipsChart";
import DailyInterventionChart from "./pages/reporting/DailyInterventionChart";
import InterventionByProcedureStats from "./pages/reporting/InterventionByProcedureStats";
import InterventionbyUserStats from "./pages/reporting/InterventionbyUserStats";
import SurgicalInterventionsStats from "./pages/reporting/SurgicalInterventionsStats";
import SurgicalInterventionsOutsStats from "./pages/reporting/SurgicalInterventionsOutsStats";

import { getProfile } from './api/Auth';

import { GlobalContext } from './GlobalContext';

import { menuItems } from "./constants";

import "./App.less";

let flatMenuItems = menuItems.flatMap((item) => {
  let items = [];
  items.push(item);
  items = items.concat(item.items);
  return items;
}).filter((item) => {
  return (item.path);
});

console.log(flatMenuItems);

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }) {
  let auth = useAuth();
  const token = localStorage.getItem("token_auth");
  const [isAuthenticated, setIsAuthenticated] = useState(token !== null);
  const [loading, setLoading] = useState(false);

  // Requis pour le context global
  const [global, updateGlobal] = useState({
    profile: null,
    config: null,
  });

  /**
   *
   */
  const refreshToken = () => {
    auth
      .refreshAccessToken()
      .then(() => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      })
      .catch(() => {
        auth.signout(() => {});
        setTimeout(() => {
          setLoading(false);
          setIsAuthenticated(false);
        }, 2000);
      });
  };

  /**
   *
   */
   const loadUser = () => {
      getProfile()
        .then((res) => res.json())
        .then((data) => {
          updateGlobal({
            ...global,
            profile: data
        });
      });
  }

  let roleIsAllowed = false;
  if (global.profile !== null) {
    flatMenuItems.forEach((item) => {
      if (item.path === rest.path) {
        if (!item.roleIds || item.roleIds.length === 0 || item.roleIds.indexOf(global.profile.role_id) > -1) {
          roleIsAllowed = true;
        }        
      }
    })
  }

  if (isAuthenticated && !loading && auth.isExpired()) {
    setLoading(true);
    refreshToken();
  } else if (global.profile === null && !loading) {
    setLoading(true);
    loadUser();
  } else if (global.profile !== null && loading) {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }

  

  return (
    <Route
      {...rest}
      render={({ location }) => {
        let state = {
          global: global,
          updateGlobal: updateGlobal,
        };

        return loading ? (
          <SplashScreen />
        ) : isAuthenticated && roleIsAllowed ? (
          <GlobalContext.Provider value={state}>
            <AppLayout>{children}</AppLayout>
          </GlobalContext.Provider>
        ) : isAuthenticated && !roleIsAllowed ? (
          <NotAuthorized />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
}

const App = () => (
  <ProvideAuth>
    <Router>
      <div>
        <Switch>
          <Redirect exact from="/" to="/home" />
          <Route exact path="/login" component={Login} />
          <Route
            exact
            path="/password/request"
            component={RequestResetPassword}
          />
          <Route exact path="/password/reset" component={ResetPassword} />
          <PrivateRoute exact path="/home">
            <Home />
          </PrivateRoute>
          <PrivateRoute exact path="/patient">
            <Patient />
          </PrivateRoute>
          <PrivateRoute exact path="/surgical_intervention">
            <SurgicalIntervention />
          </PrivateRoute>
          <PrivateRoute exact path="/calendar">
            <Calendar />
          </PrivateRoute>
          <PrivateRoute exact path="/reporting">
            <Reporting />
          </PrivateRoute>
          <PrivateRoute exact path="/daily_occupation_chart">
            <DailyOccupationChart />
          </PrivateRoute>
          <PrivateRoute exact path="/daily_siips_chart">
            <DailySiipsChart />
          </PrivateRoute>
          <PrivateRoute exact path="/daily_intervention_chart">
            <DailyInterventionChart />
          </PrivateRoute>
          <PrivateRoute exact path="/intervention_by_procedure_stats">
            <InterventionByProcedureStats />
          </PrivateRoute>
          <PrivateRoute exact path="/intervention_by_user_stats">
            <InterventionbyUserStats />
          </PrivateRoute>
          <PrivateRoute exact path="/surgical_interventions_stats">
            <SurgicalInterventionsStats />
          </PrivateRoute>
          <PrivateRoute exact path="/surgical_interventions_outs_stats">
            <SurgicalInterventionsOutsStats />
          </PrivateRoute>
          <PrivateRoute exact path="/care_units">
            <CareUnits />
          </PrivateRoute>
          <PrivateRoute exact path="/surgical_procedures">
            <SurgicalProcedures />
          </PrivateRoute>
          <PrivateRoute exact path="/users">
            <Users />
          </PrivateRoute>
        </Switch>
      </div>
    </Router>
  </ProvideAuth>
);

export default App;
